import styled from "styled-components";

export const Container = styled.div`
  min-height: calc(100vh - 50px);
  width: 100vw;

  margin-top: 50px;
  padding: 0 50px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: #282828;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Box = styled.div`
  min-height: 60vh;
  min-width: 80vw;

  padding: 50px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);

  @media screen and (max-width: 900px) {
    min-width: 100vw;
  }
`;

export const Header = styled.header`
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 28px;
  line-height: 1em;

  text-align: center;
  text-transform: uppercase;

  color: #000;

  p {
    margin-top: 20px;

    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    line-height: 1em;
  }
`;

export const CreditCardDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-left: "-10%";
  min-width: 60%;
  width: 90%;
  margin: 15px;
  padding: 20px;
`;

export const Dimmer = styled.div`
  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #fff;
  background: rgba(0, 0, 0, 0.6);
`;

export const FormLine = styled.div`
  display: grid;
  gap: 0.5rem;
  grid-template-columns: ${(props) => props.grid};
  align-items: center;
  overflow: show;

  @media screen and (max-width: 900px) {
    display: flex;
    gap: 0;
    flex-direction: column;
  }
`;
